function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var _container;
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries,
    sizes = _ref.sizes;
  return {
    container: (_container = {
      position: 'relative',
      flexDirection: 'column',
      height: '50px',
      lineHeight: '50px',
      left: 0,
      right: 0
    }, _defineProperty(_container, mediaQueries.breakpointTablet, {
      position: 'absolute',
      height: '4px',
      lineHeight: '4px'
    }), _defineProperty(_container, '&:before, &:after', {
      content: '""',
      position: 'absolute',
      width: '50%',
      height: '100%',
      top: 0,
      backgroundColor: colors.backgroundDarker
    }), _defineProperty(_container, '&:before', {
      left: 0,
      backgroundColor: colors.primary
    }), _defineProperty(_container, '&:after', {
      right: 0
    }), _defineProperty(_container, '&.completed:after', {
      backgroundColor: colors.primary
    }), _container),
    wrapper: _defineProperty({
      position: 'relative',
      display: 'flex',
      width: sizes.container,
      margin: '0 auto',
      zIndex: 1,
      overflow: 'hidden'
    }, mediaQueries.breakpointLaptop, {
      width: '100%'
    })
  };
});